// src/components/Footer.js
import React from 'react';
import './Footer.css';

const Footer = () => {
  const blogLinks = [
    { name: 'LinkedIn', url: 'https://www.linkedin.com/in/utilityguru/' },
    { name: 'Medium', url: 'https://medium.com/@miteefire' },
    { name: 'Patreon Blog', url: 'https://www.patreon.com/cw/eebootcamp' },
    { name: 'X (Twitter)', url: 'https://x.com/EEBootcamp' },
    { name: 'Facebook', url: 'https://www.facebook.com/people/EEB-Electrical-Engineer-BootCamp/100042130974444/' },
    { name: 'Dev.To', url: 'https://dev.to/eebootcamp' },
    { name: 'Tumblr', url: 'https://www.tumblr.com/blog/eebootcamp' },
    { name: 'Blogger', url: 'https://public-utilities.blogspot.com/' }
  ];

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3 className="footer-title">⚡ Power Utility & Energy Insights</h3>
          <p className="footer-description">
            Explore in-depth articles, tutorials, and industry analysis on electrical engineering, 
            renewable energy, power systems, and utility infrastructure.
          </p>
        </div>

        <div className="footer-section">
          <h4 className="footer-subtitle">📚 My Blog Network</h4>
          <div className="blog-links">
            {blogLinks.map((blog, index) => (
              <a
                key={index}
                href={blog.url}
                target="_blank"
                rel="noopener noreferrer"
                className="blog-link"
              >
                {blog.name}
              </a>
            ))}
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Electrical Engineering Bootcamp — Powering Industry Knowledge</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;